import { SpitKitSelection } from "./Types";

export const SPIT_KIT_REDUCER_NAMESPACE = "spitKitReducer";

export const DEFAULT_SPIT_KIT_SELECTION: SpitKitSelection = {
  selectAll: false,
  selectedOrders: [],
};
